import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WidgetAccessService } from '@core/services';

export const homePageGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const widgetAccessService = inject(WidgetAccessService);

  if (widgetAccessService.hasAccessibleWidgets() || widgetAccessService.hasAccesOnlyToProductLinks()) {
    return true;
  } else {
    const path = state.url.split('/').slice(0, -1).join('/');
    const firstAccessiblePage = widgetAccessService.getFirstAccessiblePage();
    return router.createUrlTree(firstAccessiblePage ? [path, firstAccessiblePage] : ['/account-not-registered']);
  }
};
